export default {
  menu: {
    grimoire: {
      title: "Гримуар",
      hide: "Скрыть",
      show: "Показать",
      switchToNight: "Переключить на ночь",
      switchToDay: "Переключить на день",
      nightOrder: "Порядок ночи",
      zoom: "Масштаб",
      backgroundImage: "Фоновое изображение",
      showCustomImages: "Показывать кастомные изображения",
      disableAnimations: "Отключить анимации",
      muteSounds: "Отключить звук",
      language: "Язык",
    },
    session: {
      title: "Сессия",
      hosting: "Рассказчик",
      playing: "Игрок",
      hostST: "Создать (Рассказчик)",
      joinPlayer: "Присоединиться (Игрок)",
      delayToHost: "Задержка до хоста",
      delayToPlayers: "Задержка до игроков",
      ms: "мс",
      copyPlayerLink: "Скопировать ссылку",
      sendCharacters: "Отправить персонажей",
      voteHistory: "История голосований",
      leaveSession: "Выйти из сессии",
    },
    players: {
      title: "Игроки",
      add: "Добавить",
      randomize: "Перемешать",
      removeAll: "Убрать всех",
    },
    characters: {
      title: "Персонажи",
      selectEdition: "Выбрать редакцию",
      chooseAssign: "Выбрать и назначить",
      addFabled: "Добавить легендарного",
      removeAll: "Убрать всех",
      clearReminders: "Очистить напоминания",
      syncState: "Синхронизировать с игроками",
    },
    help: {
      title: "Помощь",
      referenceSheet: "Справочник",
      nightOrderSheet: "Порядок ночи",
      gameStateJson: "JSON состояния игры",
      joinDiscord: "Вступить в Discord",
      sourceCode: "Исходный код",
    },
    tooltips: {
      nomination:
        "0 недавних выдвижений | {count} недавнее выдвижение | {count} недавних выдвижения | {count} недавних выдвижений",
      sessionPlayers: "{count} других игроков в сессии",
      sessionPlayersLatency:
        "{count} других игроков в сессии ({ping}мс задержки)",
    },
    prompts: {
      backgroundUrl: "Введите URL фонового изображения",
      hostSession: "Введите номер или название канала для сессии",
      joinSession: "Введите номер или название канала для подключения",
      playerName: "Имя игрока",
    },
    confirms: {
      distributeRoles: "Отправить назначенных персонажей всем ЗАНЯТЫМ игрокам?",
      customImages:
        "Разрешить кастомные изображения? Автор вредоносного файла может узнать ваш IP-адрес.",
      randomizeSeats: "Перемешать места случайным образом?",
      removePlayers: "Убрать всех игроков?",
      removeRoles: "Убрать роли всех игроков?",
      clearReminders: "Очистить все жетоны напоминаний у всех игроков?",
      syncState:
        "Синхронизировать полное состояние гримуара (роли, напоминания, состояние) со всеми игроками?",
      leaveSession: "Выйти из активной игровой сессии?",
    },
  },
  player: {
    handUp: "Рука ВВЕРХ",
    handDown: "Рука ВНИЗ",
    cancel: "Отмена",
    swapSeats: "Поменяться местами",
    moveToSeat: "Переместить на это место",
    nominate: "Выдвинуть игрока",
    ghostVote: "Голос мертвеца",
    menu: {
      changePronouns: "Изменить местоимения",
      rename: "Переименовать",
      move: "Переместить",
      swap: "Поменять места",
      remove: "Удалить",
      emptySeat: "Освободить место",
      nomination: "Выдвинуть",
      claimSeat: "Занять место",
      vacateSeat: "Покинуть место",
      seatOccupied: "Место занято",
    },
    prompts: {
      pronouns: "Местоимения игрока",
      rename: "Имя игрока",
    },
  },
  townSquare: {
    otherCharacters: "Другие персонажи",
    demonBluffs: "Блефы демона",
    fabled: "Легендарные",
    confirms: {
      removePlayer: "Удалить игрока {name}?",
    },
  },
  townInfo: {
    addMorePlayers: "Добавьте больше игроков!",
  },
  intro: {
    welcome:
      "Добро пожаловать в (неофициальный) Виртуальный Городской Сквер и Гримуар для Blood on the Clocktower!",
    addPlayers: "Пожалуйста, добавьте игроков через",
    joinSession: "Вы также можете присоединиться к сессии, нажав",
    footer:
      "Этот проект является бесплатным с открытым исходным кодом, доступен на GitHub. Не аффилирован с The Pandemonium Institute. «Blood on the Clocktower» является торговой маркой Стивена Медуэя и The Pandemonium Institute.",
    chineseVersion: "你想使用中文版魔典吗?",
  },
  vote: {
    nominated: "{nominator} выдвигает {nominee}!",
    voteCount:
      "0 голосов за | {count} голос за | {count} голоса за | {count} голосов за",
    majority: "(большинство: {count})",
    timePerPlayer: "Время на игрока:",
    countdown: "Отсчёт",
    start: "Старт",
    restart: "Перезапуск",
    pause: "Пауза",
    resume: "Продолжить",
    reset: "Сброс",
    close: "Закрыть",
    markExecution: "Отметить для казни",
    clearMark: "Снять отметку",
    secondsBetweenVotes: "{seconds} секунд между голосами",
    handDown: "Рука ВНИЗ",
    handUp: "Рука ВВЕРХ",
    claimSeatToVote: "Займите место, чтобы проголосовать.",
    go: "СТАРТ",
  },
  teams: {
    townsfolk: "Горожане",
    outsider: "Чужаки",
    minion: "Прислужники",
    demon: "Демон",
    traveler: "Путники",
    fabled: "Легендарные",
  },
  modals: {
    edition: {
      selectEdition: "Выберите редакцию:",
      customScript: "Собственный скрипт / персонажи",
      loadCustomScript: "Загрузить собственный скрипт / персонажей",
      instructions:
        "Для игры с собственным скриптом выберите нужных персонажей в официальном Script Tool и загрузите сгенерированный файл «custom-list.json» напрямую или укажите URL к размещённому JSON файлу.",
      scriptToolLink: "Script Tool",
      customCharsInstructions:
        "Для игры с кастомными персонажами ознакомьтесь с документацией по созданию файла определения персонажей.",
      customCharsLink: "Кастомные персонажи",
      warning:
        "Загружайте кастомные JSON файлы только из доверенных источников!",
      popularScripts: "Популярные скрипты:",
      uploadJson: "Загрузить JSON",
      enterUrl: "Ввести URL",
      useClipboard: "Из буфера обмена",
      back: "Назад",
      prompts: {
        enterUrl: "Введите URL файла custom-script.json",
      },
      errors: {
        reading: "Ошибка чтения скрипта: ",
        loading: "Ошибка загрузки скрипта: ",
      },
    },
    fabled: {
      chooseCharacter: "Выберите легендарного персонажа для добавления в игру",
    },
    gameState: {
      title: "Текущее состояние игры",
      copyJson: "Копировать JSON",
      loadState: "Загрузить состояние",
      errors: {
        parseJson: "Не удалось разобрать JSON: ",
      },
    },
    nightOrder: {
      title: "Порядок ночи",
      customScript: "Собственный скрипт",
      firstNight: "Первая ночь",
      otherNights: "Другие ночи",
      minionInfo: "Инфо для прислужников",
      minionInfoText:
        "• Если прислужников больше одного — они встречаются взглядом. • Покажите карту «Это демон». Укажите на демона.",
      demonInfo: "Инфо для демона и блефы",
      demonInfoText:
        "• Покажите карту «Это ваши прислужники». Укажите на каждого. • Покажите карту «Этих персонажей нет в игре». Покажите 3 жетона персонажей света, которых нет в игре.",
      showReference: "Показать справочник",
    },
    reference: {
      title: "Справочник персонажей",
      customScript: "Собственный скрипт",
      jinxed: "Проклятые",
      showNightOrder: "Показать порядок ночи",
    },
    reminder: {
      chooseToken: "Выберите жетон напоминания:",
      good: "Добро",
      evil: "Зло",
      customNote: "Заметка",
      prompts: {
        customNote: "Добавить заметку",
      },
    },
    role: {
      chooseForPlayer: "Выбрать нового персонажа для {name}",
      chooseForBluff: "Выбрать нового персонажа для блефа",
      editionRoles: "Персонажи редакции",
      otherTravelers: "Другие странники",
    },
    roles: {
      selectCharacters: "Выберите персонажей для {count} игроков:",
      warning:
        "Внимание: выбраны персонажи, изменяющие состав игры! Генератор не учитывает этих персонажей.",
      allowDuplicates: "Разрешить повторяющихся персонажей",
      assignRoles: "Назначить {count} персонажей случайно",
      shuffleCharacters: "Перемешать персонажей",
    },
    voteHistory: {
      title: "История голосований",
      time: "Время",
      nominator: "Выдвигающий",
      nominee: "Кандидат",
      type: "Тип",
      votes: "Голоса",
      majority: "Большинство",
      voters: "Голосующие",
      accessibleToPlayers: "Доступно игрокам",
      clearForEveryone: "Очистить для всех",
      clearHistory: "Очистить историю",
    },
  },
};
